import React from 'react';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useTranslation } from 'react-i18next';
import enLocale from 'date-fns/locale/en-US';
import esLocale from 'date-fns/locale/es';

const localeMap = {
  en: enLocale,
  es: esLocale,
};

const LocalizedMuiPickersProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const locale = localeMap[i18n.language] || enLocale;

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
      {children}
    </MuiPickersUtilsProvider>
  );
};

export default LocalizedMuiPickersProvider;
